import EPGChannelImage from './EPGChannelImage';

export default EPGChannelImage;
